import React from 'react'

import { Helmet, HelmetProvider } from 'react-helmet-async'

// ゲットナビゲータ
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ScrollToTop from "../ScrollToTop";

// スタイルインポート
import "../common.scss";
import "../pages/css/privacy.scss";
import "../responsive/PrivacyResponsive.scss";

// メインビジュアル
import headerSubImg from "../img/privacy/privacy-img.jpg";

// framer motion
import { motion } from "framer-motion";

function Privacy() {
  return (
    <motion.div
    className="works"
    initial={{ width: 0 }}
    animate={{ width: "100%" }}
    exit={{ x: window.innerWidth, transition: { duration: 0.1 } }}
    >
        <HelmetProvider>
			<Helmet prioritizeSeoTags>
			<meta charset="utf-8" />
			<meta name="viewport" content="width=device-width, initial-scale=1" />
			<meta name="theme-color" content="#005bac" />
			<meta
				name="keywords"
				content="千葉県千葉市web制作,千葉市格安ホームページ制作,千葉市web集客,smartgenz,パドリナアレン,smartgenzとは？.smartgenzプライバシーポリシー"
			/>
			<meta
				name="description"
				content="千葉市を拠点とする制作事務所、SmartGenzのプライバシーポリシーについてです！こちらのページはプライバシーポリシーについてご覧いただけます。"
			/>
			<meta property="og:title" content="千葉県千葉市でのホームページ制作ならSmartGenz | プライバシーポリシー" />
			<meta
				property="og:description"
				content="千葉市を拠点とする制作事務所、SmartGenzのプライバシーポリシーについてです！こちらのページはプライバシーポリシーについてご覧いただけます。"
			/>
			<meta property="og:type" content="article" />
			<meta property="og:url" content="https://smartgenz.com/privacy" />
			<meta property="og:image" content="%PUBLIC_URL%/smartgenz.jpg" />
			<meta property="og:site_name" content="千葉県千葉市でのホームページ制作ならSmartGenz | プライバシーポリシー" />
			<meta property="og:locale" content="ja_JP" />
			<link rel="apple-touch-icon" href="%PUBLIC_URL%/smartgenz.jpg" />
			<link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
			<link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
			<link rel="canonical" href="https://smartgenz.com/privacy" />
			<title>千葉県千葉市でのホームページ制作ならSmartGenz | プライバシーポリシー</title>
			</Helmet>
		</HelmetProvider>
        <article className="sub-image">
            <div className="sub-main-image position-about">
                <img
                    src={headerSubImg}
                    alt="アイテム　｜ ヘッダーイメージ"
                ></img>
            </div>
        </article>
        <section class="wrk-sec">
            <div class="sub-sec-company-ttl">
                <div class="borderA"></div>
                <h2 data-desc="個人情報保護方針">PRIVACY</h2>
                <div class="borderB"></div>
            </div>
        </section>
        <section className="privacy-main-sec">
            <div className='privacy-main-point'>
            SmartGenz（以下、「当社」という。）は，ユーザーの個人情報について以下のとおりプライバシーポリシー（以下、「本ポリシー」という。）を定めます。本ポリシーは、当社がどのような個人情報を取得し、どのように利用・共有するか、ユーザーがどのようにご自身の個人情報を管理できるかをご説明するものです。
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>1.個人情報の取得方法</h2>
                    <div className="txt">当方はお客様がお問い合わせフォームを送信するとき、資料ダウンロード請求フォームを送信するとき、氏名・電話番号・メールアドレスなど個人を特定できる情報を取得させていただきます。</div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>2.個人情報の利用目的</h2>
                    <div className="txt">当方では収集した個人情報を以下の目的で利用します。
                        <ul className='many-lines'>
                            <li>サービスに関する情報の提供のため</li>
                            <li>施策やアフターサービス、マーケティング支援を適切に提供するため</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>3.個人情報の第三者への開示・提供の禁止</h2>
                    <div className="txt">当方は、お客様よりお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。
                        <ul className='many-lines'>
                            <li>お客様の同意がある場合</li>
                            <li>お客様が希望されるサービスを行なうために当方が業務を委託する業者に対して開示する場合</li>
                            <li>法令に基づき開示することが必要である場合</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>4.Cookieについて</h2>
                    <div className="txt">cookieとは、WebサーバーからWebブラウザに送信されるデータのことです。Webサーバーがcookieを参照することでユーザーのパソコンを識別でき、効率的に当社Webサイトを利用することができます。当社Webサイトがcookieとして送るファイルは、個人を特定するような情報は含んでおりません。 お使いのWebブラウザの設定により、cookieを無効にすることも可能です。</div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>5.第三者によるCookie情報の取得について</h2>
                    <div className="txt">当WEBサイトでは、グーグル株式会社やヤフー株式会社などをはじめとする第三者から配信される広告が掲載される場合があり、これに関連して当該第三者が訪問者のCookie情報等を取得して、利用している場合があります。当該第三者によって取得されたCookie情報等は、当該第三者のプライバシーポリシーに従って取り扱われます。
                        <div className="other-site">ヤフー株式会社　<a href='https://privacy.yahoo.co.jp/' target='_blank'>https://privacy.yahoo.co.jp/</a></div>
                        <div className="other-site">Google Inc.及びグーグル株式会社　<a href='https://policies.google.com/privacy?gl=jp' target='_blank'>https://policies.google.com/privacy?gl=jp</a></div>
                    </div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>6.第三者へのCookie情報等の広告配信の利用停止について</h2>
                    <div className="txt">お客様は、当該第三者のWEBサイト内に設けられたオプトアウト（個人情報を第三者に提供することを停止すること）ページにアクセスして、当該第三者によるCookie情報等の広告配信への利用を停止することができます。</div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>7.アクセス解析ツールについて</h2>
                    <div className="txt">当WEBサイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。<br />このGoogleアナリティクスはアクセス情報の収集のためにCookieを使用しています。このアクセス情報は匿名で収集されており、個人を特定するものではありません。<br />GoogleアナリティクスのCookieは、50ヶ月間保持されます。この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。<br />Googleアナリティクスの利用規約に関して確認したい場合は、こちらからご確認ください。</div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>8.ご本人の照会</h2>
                    <div className="txt">お客様がご本人の個人情報の照会・修正・削除などをご希望される場合には、ご本人であることを確認の上、対応させていただきます。</div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>9.SSL（Secure Socket Layer）について</h2>
                    <div className="txt">当WEBサイトはSSLに対応しており、WEBブラウザとWEBサーバーとの通信を暗号化しています。お客様が入力する氏名や電話番号などの個人情報は自動的に暗号化されます。</div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>10.プライバシーポリシーの変更について</h2>
                    <div className="txt">当WEBサイトは、個人情報に関して適用される日本の法令を遵守するとともに、本プライバシーポリシーの内容を適宜見直しその改善に努めます。修正された最新のプライバシーポリシーは常に本ページにて開示されます。</div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>11.免責事項</h2>
                    <div className="txt">当社Webサイトに掲載されている情報の正確性には万全を期していますが、利用者が当社Webサイトの情報を用いて行う一切の行為に関して、一切の責任を負わないものとします。 当社は、利用者が当社Webサイトを利用したことにより生じた利用者の損害及び利用者が第三者に与えた損害に関して、一切の責任を負わないものとします。</div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>12.著作権・肖像権</h2>
                    <div className="txt">当WEBサイト内の文章や画像、すべてのコンテンツは著作権・肖像権等により保護されています。無断での使用や転用は禁止されています。</div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>13.リンク</h2>
                    <div className="txt">当社WEBサイトのリンクを自由に設置していただいても構いません。ただし、Webサイトの内容等によってはリンクの設置をお断りすることがあります。</div>
                </div>
            </div>
            <div className="privacy-contract">
                <div className="point">
                    <h2 className='title'>14.個人情報の取扱いに関する問合せ先</h2>
                    <div className="txt">お問い合わせ窓口は、以下の通りです。</div>
                    <div className="contact">
                        <p>屋号：SmartGenz（スマートジェンズ）</p>
                        <p>個人情報担当：アイテム</p>
                        <p>電話番号：043-356-0300</p>
                    </div>
                </div>
            </div>
        </section>
        <ScrollToTop />
        <Contact />
        <Footer />
    </motion.div>
  )
}

export default Privacy;